import { useQuery } from "@apollo/client";
import { Fab, makeStyles, Tooltip, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import lodash from "lodash";
import { useSnackbar } from "notistack";
import React from "react";
import { CompanyDialog, CompanyList } from "../../components/Company";
import { SearchField } from "../../components/Search";
import { LIST_ALL_COMPANIES_FILTERED } from "../../graphql/queries";
import { ListAllComapniesQuery } from "../../graphql/queries/listAllCompanies";
import { ListAllCompaniesQueryVariables } from "../../graphql/types";
import useSiteTitle from "../../hooks/useSiteTitle";

interface Props {}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

const Companies: React.FC<Props> = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [showDialog, setShowDialog] = React.useState<boolean>(false);
  const [searchValue, setSearchValue] = React.useState<string | undefined>("");

  useSiteTitle("Auftraggeber");
  const classes = useStyles();

  const { data, loading, fetchMore } = useQuery<
    ListAllComapniesQuery,
    ListAllCompaniesQueryVariables
  >(LIST_ALL_COMPANIES_FILTERED, {
    variables: {
      name: searchValue,
    },
    onError(error) {
      console.log(error);
      enqueueSnackbar("Fehler beim laden der Auftraggeber", {
        variant: "error",
      });
    },
  });

  const { listCompanys } = data || { listCompanys: { items: [] } };
  const { items, nextToken } = listCompanys || {};

  const _handleClientSearch = lodash.debounce(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setSearchValue(event.target.value);
    },
    500
  );

  const _handleCleareSearch = () => {
    setSearchValue("");
  };
  const _handleCloseDialog = () => {
    setShowDialog(false);
  };
  const _openDialog = () => {
    setShowDialog(true);
  };
  return (
    <div className={classes.root}>
      <CompanyDialog open={showDialog} handleClose={_handleCloseDialog} />
      <div className={classes.header}>
        <Typography variant="h3">Auftraggeber</Typography>
        <SearchField
          onClearSearch={_handleCleareSearch}
          onSearchChange={_handleClientSearch}
          value={searchValue}
        />
        <Tooltip title="Auftraggeber hinzufügen">
          <Fab
            aria-label="create employee"
            size={"small"}
            disabled={loading}
            onClick={_openDialog}
            color={"primary"}
          >
            <AddIcon />
          </Fab>
        </Tooltip>
      </div>

      <CompanyList
        items={items || []}
        loading={loading}
        hasMore={!!nextToken}
        loadMore={() => {
          if (nextToken) {
            fetchMore({
              variables: { name: searchValue, nextToken },
            });
          }
        }}
      />
    </div>
  );
};

export default Companies;
